module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAADgCAIAAABjIy8HAAAAA3NCSVQFBQUYJt5DAAABEklEQVR4nO3XQQrEMAgAwFr6/y+7h0LZQ7ukKVkJnTkGEQkquCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQKOoLmBWmXn6HnH+paPj4a+uGrQqnj5bdQHTOzq1fTdn5q3gu/lhuL0vv/f0753dHtmXnz5rdQFQyQDwagaAV3MEPxIRQ4/U0fkBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYxgeJFzj1eZjL/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/debug/doremiDebug_00000.png
// module id = 302
// module chunks = 0